export interface IChat {
  id: number;
  outId: number;
  isPinned: number;
  messageDate: number;
  writerHandle: string;
  writerDisplayname: string;
  writerProfilePic: string;
  message: string;
  attachments: IChatAttachment[];
  replyToObject: IChat;
  messageId: number;
  messageStatus: number;
  highlighted: boolean;
  taggedUsers: {
    taggedUsers: {
      id: number;
      handle: string;
    }[];
  };
  key?: number;
  len?: number;
}

export enum MessageStatusEnum {
  ORIGINAL_MESSAGE = 1,
  REPLIED_MESSAGE = 2,
  ORIGINAL_MESSAGE_DELETED = 3,
}

export interface IChatAttachment {
  url: string;
  contentType: string;
}
